import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=ec0f22fc&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Category.vue?vue&type=style&index=1&id=ec0f22fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0f22fc",
  null
  
)

export default component.exports